import * as React from "react";
import { Image, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { showFullscreenCamera, hideClaimsV2StepsScreen } from "../../../actions/fullscreenActions";
import './ClaimsV2PhotoCover.css';

class ClaimsV2PhotoCover extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }


    async handleClick() {
        this.props.dispatchHideClaimsV2StepsScreen();
        this.props.dispatchShowFullscreenCamera();
    }

    render() {
        return (
            <>
                <div id="FNOLPhotoCover" className="LoadingDiv p-4 text-center">
                    <div className="row align-items-center h-100">
                        <div className="col-12 align-self-center">
                            <h2 className="Welcome">{this.props.claimSubmit.selectedDamagePhotoTypes.description}</h2>
                            <Image src="./Images/FNOL/photo-camera.png" alt="loading" className="img-fluid gif" />
                            <div className="bottom-steps test-center ">
                                <p className="text-white mt-3">Take a photo of the damage</p>
                                <p className="text-white">Please ensure the damage can be clearly seen in the photo</p>
                                <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideClaimsV2StepsScreen: () => dispatch(hideClaimsV2StepsScreen()),
        dispatchShowFullscreenCamera: () => dispatch(showFullscreenCamera()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsV2PhotoCover)
